import { useContext } from 'react';
import { OrgPreferencesContext } from '../contexts/OrgPreferences/OrgPreferencesContext';

const useOrgPreferences = () => useContext(OrgPreferencesContext);

export default useOrgPreferences;
